module.exports = __webpack_public_path__ + "img/img_top.8b1ee836.png";